import { format } from '@jd/jmtd-tools/es/number';
export default function TableFormatterNumber(_ref) {
  var numberFormat = _ref.format;
  return {
    align: 'right',
    monoSpaced: true,
    render: function render(text) {
      return text == null ? '- -' : format(text, numberFormat);
    }
  };
}